import { decodeJwtClaims } from "./decodeJwtClaims";

type JwtClaimsWithExp = {
  exp?: number;
};

/** Returns true when JWT is missing/invalid/expired (with small clock skew). */
export function isAccessTokenExpired(
  token: string | null | undefined,
): boolean {
  if (!token) return true;
  const claims = decodeJwtClaims(token) as
    | (JwtClaimsWithExp & Record<string, unknown>)
    | null;
  if (!claims?.exp || typeof claims.exp !== "number") return true;
  const nowSeconds = Math.floor(Date.now() / 1000);
  const clockSkewSeconds = 10;
  return claims.exp <= nowSeconds + clockSkewSeconds;
}
